<div class="DocPropia ">
  <div class="tab-boxdoc">
    <div class="title-ind">
      <h1 class="title-tab">Documentación Propia</h1>
    <div class="displayFlexEvenly">
      <div class="docpropia__titulo mat-elevation-z8">
        <form [formGroup]="datosDocumento" >
          <div class="datos">
            <h2>Seguridad Social</h2>
            <p>Debe subir el <strong>Certificado de estar al corriente en las Obligaciones de la Seguridad Social </strong></p>
          </div>
          <div class="docpropia__drop">
            <ngx-file-drop dropZoneClassName="drop"  contentClassName="drop_content" dropZoneLabel="Drop files here" (onFileDrop)="dropped1($event)" 
            (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
            <ng-template ngx-file-drop-content-tmp 
                let-openFileSelector="openFileSelector">
                <ng-container *ngIf="nameDocumento1">{{nameDocumento1}}</ng-container>
              <ng-container *ngIf="!nameDocumento1">Puedes soltar aquí los documentos o</ng-container>
                <button type="button" class="boton_drop" (click)="openFileSelector()">Seleccionar un archivo</button>
            </ng-template>
            </ngx-file-drop>
           
          </div>
          <div>
              <p>Seleccione la <strong>Fecha de Emisión</strong> y la <strong>Fecha de Caducidad </strong>del documento:</p>
              <div>
                <mat-hint>La fecha se especifica en las condiciones informáticas o referencias electrónicas al pie de página del documento
                </mat-hint>
              </div>      
              <mat-form-field appearance="outline" class="example-form-field">
                <mat-label>Fecha de Emisión</mat-label>
                <input matInput 
                    required 
                    formControlName="fechaValidez"
                    [matDatepicker]="datepicker">
                <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker>
                  <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancelar</button>
                    <button mat-raised-button color="primary" matDatepickerApply >Hecho</button>
                  </mat-datepicker-actions>
                </mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="outline" class="example-form-field">
                <mat-label>Fecha de Caducidad</mat-label>
                <input matInput 
                    required 
                    formControlName="fechaCaducidad"
                    [matDatepicker]="datepicker3">
                <mat-datepicker-toggle matSuffix [for]="datepicker3"></mat-datepicker-toggle>
                <mat-datepicker #datepicker3>
                  <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancelar</button>
                    <button mat-raised-button color="primary" matDatepickerApply >Hecho</button>
                  </mat-datepicker-actions>
                </mat-datepicker>
              </mat-form-field>
             
              <div *ngIf="seguridadSocial === null || !seguridadSocial || docSeguridad == undefined || docSeguridad.length == 0" class="boton__siguiente">
                <button
                  type="submit"
                  (click)="addDocumento()"
                  [disabled]="datosDocumento.invalid"
                >
                  Hecho
                </button>
            </div>
          </div>
            </form>
            <ng-container *ngIf="docSeguridad && docSeguridad?.length > 0"  >
              <p class="message-doc">Si desea actualizar la documentación de Seguridad Social, por favor pinche en el documento correspondiente en la tabla</p>
             </ng-container >
          </div>

    <div class="docpropia__titulo mat-elevation-z8">
      <form [formGroup]="datosHacienda" >
        <div class="datos2">
            <h2>Hacienda</h2>
            <p>Debe subir el <strong>Certificado de estar al corriente de sus obligaciones tributarias</strong> </p>
        </div>
        <div class="docpropia__drop">
            <ngx-file-drop dropZoneClassName="drop" contentClassName="drop_content" dropZoneLabel="Drop files here" (onFileDrop)="dropped2($event)" 
            (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
            <ng-template ngx-file-drop-content-tmp 
                let-openFileSelector="openFileSelector">
                <ng-container *ngIf="nameDocumento2">{{nameDocumento2}}</ng-container>
                <ng-container *ngIf="!nameDocumento2">Puedes soltar aquí los documentos o</ng-container>
                <button type="button" class="boton_drop" (click)="openFileSelector()">Seleccionar un archivo</button>
            </ng-template>
            </ngx-file-drop>
           
        </div>
         <div>
            <p>Seleccione la <strong>Fecha de Emisión</strong> y la <strong>Fecha de Caducidad </strong>del documento:</p>
            <div>
            <mat-hint>La fecha se localiza en el último párrafo del certificado. La duración a seleccionar se deberá corresponder con la validez especificada (seis o doce meses)
            </mat-hint>
          </div>
          <mat-form-field appearance="outline" class="example-form-field">
            <mat-label>Fecha de Emisión</mat-label>
            <input matInput 
                required 
                formControlName="fechaValidez"
                [matDatepicker]="datepicker1">
            <mat-datepicker-toggle matSuffix [for]="datepicker1"></mat-datepicker-toggle>
            <mat-datepicker #datepicker1>
              <mat-datepicker-actions>
                <button mat-button matDatepickerCancel>Cancelar</button>
                <button mat-raised-button color="primary" matDatepickerApply>Hecho</button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" class="example-form-field">
            <mat-label>Fecha de Caducidad</mat-label>
            <input matInput 
                required 
                formControlName="fechaCaducidad"
                [matDatepicker]="datepicker2">
            <mat-datepicker-toggle matSuffix [for]="datepicker2"></mat-datepicker-toggle>
            <mat-datepicker #datepicker2>
              <mat-datepicker-actions>
                <button mat-button matDatepickerCancel>Cancelar</button>
                <button mat-raised-button color="primary" matDatepickerApply >Hecho</button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </mat-form-field>
          <div *ngIf="!hacienda || hacienda === null || docHacienda === undefined || docHacienda.length == 0" class="boton__siguiente">
            <button
              type="submit"
              (click)="addHacienda()"
              [disabled]="datosHacienda.invalid"
            >
              Hecho
            </button>
          </div>
        </div>
          
          </form>
          <ng-container *ngIf="docHacienda && docHacienda?.length > 0"  >
            <p class="message-doc">Si desea actualizar la documentación de Hacienda, por favor pinche en el documento correspondiente en la tabla</p>
           </ng-container >
          </div>
</div>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" >
        <ng-container matColumnDef="nombre">
          <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
            NOMBRE DOCUMENTO
          </th>>
          <td mat-cell *matCellDef="let documento" (click)="openValidation(documento.id)">
            {{documento.nombre}}   
          </td>
        </ng-container>
        <ng-container matColumnDef="indicador">
          <th color="primary" mat-header-cell *matHeaderCellDef >
            INDICADOR
          </th>
          <td mat-cell *matCellDef="let documento" (click)="openValidation(documento.id)">
            <div *ngIf="!documento.validado" class="documentos-indicadores" >
              <img  src="../../../../../assets/pendiente-de-validar.svg"
               #tooltip="matTooltip"  matTooltip="Pendiente de validar" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.enFecha && documento.tipo === 'seguridadSocialActivo'" class="documentos-indicadores">
              <img  src="../../../../../assets/validado.svg" 
              #tooltip="matTooltip"  matTooltip="Validado" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.proximoCaduca && documento.tipo === 'seguridadSocialActivo'" class="documentos-indicadores">
              <img  src="../../../../../assets/proximo-a-caducar.svg" 
               #tooltip="matTooltip"  matTooltip="Próximo a caducar" matTooltipPosition="left"/>
            </div>
            <div *ngIf="documento.caducado && documento.tipo === 'seguridadSocialActivo'" class="documentos-indicadores">
              <img  src="../../../../../assets/caducado.svg" 
              #tooltip="matTooltip"  matTooltip="Caducado" matTooltipPosition="left" />
            </div> 
            <div *ngIf="documento.enFecha && documento.tipo === 'seguridadSocialActivoEnEspera'" class="documentos-indicadores1">
              <img  src="../../../../../assets/verde.png" 
              #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
            </div> 
            <div *ngIf="documento.caducado && documento.tipo === 'seguridadSocialActivoEnEspera'" class="documentos-indicadores1">
              <img  src="../../../../../assets/rojo.png" 
              #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
            </div> 
            <div *ngIf="documento.proximoCaduca && documento.tipo === 'seguridadSocialActivoEnEspera'" class="documentos-indicadores1">
              <img  src="../../../../../assets/Amarillo.png" 
              #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.enFecha && documento.tipo === 'haciendaActivo'" class="documentos-indicadores">
              <img  src="../../../../../assets/validado.svg" 
              #tooltip="matTooltip"  matTooltip="Validado" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.proximoCaduca && documento.tipo === 'haciendaActivo'" class="documentos-indicadores">
              <img  src="../../../../../assets/proximo-a-caducar.svg" 
               #tooltip="matTooltip"  matTooltip="Próximo a caducar" matTooltipPosition="left"/>
            </div>
            <div *ngIf="documento.caducado && documento.tipo === 'haciendaActivo'" class="documentos-indicadores">
              <img  src="../../../../../assets/caducado.svg" 
              #tooltip="matTooltip"  matTooltip="Caducado" matTooltipPosition="left" />
            </div> 
            <div *ngIf="documento.enFecha && documento.tipo === 'haciendaActivoEnEspera'" class="documentos-indicadores1">
              <img  src="../../../../../assets/verde.png" 
              #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
            </div> 
            <div *ngIf="documento.caducado && documento.tipo === 'haciendaActivoEnEspera'" class="documentos-indicadores1">
              <img  src="../../../../../assets/rojo.png" 
              #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
            </div> 
            <div *ngIf="documento.proximoCaduca && documento.tipo === 'haciendaActivoEnEspera'" class="documentos-indicadores1">
              <img  src="../../../../../assets/Amarillo.png" 
              #tooltip="matTooltip"  matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
            </div>
            <!-- <div *ngIf="documento.comentariosNuevos === true" class="documentos-indicadores">
              <img  src="../../../../../assets/comentario-.svg"
              #tooltip="matTooltip"  matTooltip="Con comentarios" matTooltipPosition="right" />
            </div>  -->
          </td>
        </ng-container>
        <ng-container matColumnDef="fechaEmision">
          <th color="primary" mat-header-cell *matHeaderCellDef >
            FECHA EMISIÓN
          </th>
          <td mat-cell *matCellDef="let documento" (click)="openValidation(documento.id)">
              {{ documento.fechaValidez | date: 'dd/MM/yyyy'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="fechaCaducidad">
          <th color="primary" mat-header-cell *matHeaderCellDef >
            FECHA CADUCIDAD
          </th>
          <td mat-cell *matCellDef="let documento" (click)="openValidation(documento.id)">
            {{ documento.fechaCaducidad | date: 'dd/MM/yyyy'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="acciones">
          <th color="primary" mat-header-cell *matHeaderCellDef >
            ACCIONES
          </th>
          <td mat-cell *matCellDef="let documento">
            <div *ngIf="documento.validado === false">
            <img
            class="tabla-borrar"
            src="../../../../../../assets/trash.png"
            (click)="handleClick(documento.id)"
          />
        </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns; let documento" class="scroll"></tr>
      </table>
    </div>
    

